var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeedbackReceivedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8617 4.98667L18.5492 3.29917C19.2814 2.56694 20.4686 2.56694 21.2008 3.29917C21.9331 4.03141 21.9331 5.21859 21.2008 5.95083L10.5822 16.5695C10.0535 17.0981 9.40144 17.4868 8.68489 17.7002L6 18.5L6.79978 15.8151C7.01323 15.0986 7.40185 14.4465 7.93052 13.9178L16.8617 4.98667ZM16.8617 4.98667L19.5 7.62499M18 14.5V19.25C18 20.4926 16.9926 21.5 15.75 21.5H5.25C4.00736 21.5 3 20.4926 3 19.25V8.74999C3 7.50735 4.00736 6.49999 5.25 6.49999H10",
    stroke: "#1E1E1E",
    strokeOpacity: 0.8,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackReceivedIcon);
export default __webpack_public_path__ + "static/media/feedback-received-icon.0c203f61c66fc894e1638cc3a7e2f17d.svg";
export { ForwardRef as ReactComponent };